import {memo, SVGProps} from 'react';

export const OutOfOfficeIcon = memo(
  ({color = '#5F5F8C', ...props}: SVGProps<SVGSVGElement>) => (
    <svg
      aria-hidden="true"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <circle cx="9" cy="9" r="7.25" stroke={color} strokeWidth="1.5" />
      <path
        d="M5.25 9H12.75"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
);

OutOfOfficeIcon.displayName = 'OutOfOfficeIcon';
